import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW4200Component } from './kymw4200.component';
import { SharedModule } from '../../../shared/shared.module';
import { FileDownloadService } from '../../../commons/kymw02/file-download-confirm/file-download.service';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetCandidateGoodsProofListService } from './api-services/get-candidate-goods-proof-list.service';
import { OutputGoodsMasterProofService } from './api-services/output-goods-master-proof.service';

/**
 * モジュール設定クラス
 *
 * @export KYMW4200Module
 * @class KYMW4200Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    WjGridModule,
    SharedModule,
    AppCommonsModule
  ],
  declarations: [
    KYMW4200Component,
  ],
  providers: [
    GetCandidateGoodsProofListService,
    OutputGoodsMasterProofService,
  ],
})
export class KYMW4200Module {

}
